import { SkillCategory } from '@applicator/shared'

export function compareSkillNames(a: string, b: string): number {
  return (a || '').localeCompare(b || '', 'en', { sensitivity: 'base' })
}

export function sortSkillsInCategories(categories: SkillCategory[]): SkillCategory[] {
  return categories.map((cat) => ({
    ...cat,
    skills: [...(cat.skills || [])].sort((a, b) => compareSkillNames(a.name, b.name)),
  }))
}
